<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <!--                <v-btn :to="{name: 'notifications.index'}"  class="btn-back">-->
                <!--                  <span class="flaticon2-reply icon-lg" ></span>-->
                <!--                  بازگشت-->
                <!--                </v-btn>-->
                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->
                <v-btn
                  @click="addNotification"
                  :loading="loading"
                  class="submit-btn"
                  v-status="'notification_create'"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="title"
                      label="عنوان"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="notify_type"
                      :items="notify_types"
                      item-text="value"
                      v-on:change="notifyStatus"
                      item-value="name"
                      outlined
                      dense
                      label="نوع اطلاع رسانی"
                    >
                    </v-select>
                  </v-flex>
                </v-row>
                <v-row>
                  <!--                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">-->
                  <!--                    <v-text-field-->
                  <!--                        v-model="cost"-->
                  <!--                        label="نرخ پیامک"-->
                  <!--                        :disabled="!textArea"-->
                  <!--                        outlined-->
                  <!--                        dense-->
                  <!--                    ></v-text-field>-->
                  <!--                  </v-flex>-->
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <date-picker
                      v-model="extras.notify_at"
                      label="تاریخ ارسال"
                      format="YYYY-MM-DD HH:mm"
                      type="datetime"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <user-picker v-model="users"></user-picker>
                    <!--                <permission-picker></permission-picker>-->
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-if="notify_type == 'notification'"
                      v-model="extras.icon"
                      :items="icons"
                      item-text="value"
                      item-value="name"
                      outlined
                      dense
                      label="ایکون"
                    >
                    </v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="notify">
                    <ckeditor
                      v-if="ckEditor"
                      :editor="editor.editor"
                      v-model="text"
                      :config="editor.editorConfig"
                    ></ckeditor>
                  </v-flex>
                  <v-textarea
                    v-if="textArea"
                    v-model="text"
                    dense
                    outlined
                    label="متن پیام"
                  ></v-textarea>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import PermissionPicker from "@/view/pages/pickers/permissionPicker";
import userPicker from "@/view/pages/pickers/userPicker";

export default {
  components: { PermissionPicker, userPicker },
  data() {
    return {
      loading: false,
      title: "",
      notify: false,
      text: "",
      ckEditor: false,
      textArea: true,
      notify_type: "sms",
      icons: [
        { name: "info", value: "اطلاع رسانی" },
        { name: "success", value: "موفقیت" },
        { name: "warning", value: "هشدار" },
        { name: "danger", value: "خطر" },
      ],
      notify_types: [
        { name: "sms", value: "پیامک" },
        { name: "email", value: "ایمیل" },
        { name: "notification", value: "نوتیفیکیشن" },
        // {name: 'push_notification', value: 'اطلاع رسانی پنل'}
      ],
      cost: "",
      users: [],
      extras: {
        notify_at: "",
        icon: "",
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
    };
  },
  methods: {
    addNotification() {
      this.loading = true;
      this.requestApiPost("notification", {
        title: this.title,
        text: this.text,
        notify_type: this.notify_type,
        cost: 0,
        extras: this.extras,
        users: this.users,
      })
        .then((response) => {
          this.loading = false;
          this.$toast.success("اطلاع رسانی با موفقیت ارسال شد.");
          this.$router.push({ name: "notifications.index" });
        })
        .catch(({ response }) => {
          this.errors = response.data;
          this.loading = false;
        });
    },
    notifyStatus(data) {
      if (data.name === "sms") {
        this.ckEditor = false;
        this.textArea = true;
        this.notify = false;
      } else {
        this.notify = true;
        this.textArea = false;
        this.ckEditor = true;
        this.cost = "";
      }
    },
  },
};
</script>
